import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=0628686a&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"
import style0 from "./Access.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports